export default {"src":"/_next/static/media/collaborations.7e0eb6f0.svg","height":558,"width":787};